
import React, { useState } from 'react';

const InterestCalculator = () => {
  const [section, setSection] = useState('234A');
  const [taxableIncome, setTaxableIncome] = useState(0);
  const [taxPaid, setTaxPaid] = useState(0);
  const [dueDate, setDueDate] = useState('');
  const [filingDate, setFilingDate] = useState('');
  const [assessedTax, setAssessedTax] = useState(0);
  const [advanceTaxPaid, setAdvanceTaxPaid] = useState(0);
  const [taxLiability, setTaxLiability] = useState(0);
  const [installments, setInstallments] = useState({
    q1: 0,
    q2: 0,
    q3: 0,
    q4: 0,
  });
  const [refundGranted, setRefundGranted] = useState(0);
  const [actualRefund, setActualRefund] = useState(0);
  const [interest, setInterest] = useState(0);

  const calculateInterest = () => {
    let calculatedInterest = 0;
    switch (section) {
      case '234A':
        const netTax = taxableIncome - taxPaid;
        if (netTax > 0 && filingDate > dueDate) {
          const dueDateObj = new Date(dueDate);
          const filingDateObj = new Date(filingDate);
          const months =
            (filingDateObj.getFullYear() - dueDateObj.getFullYear()) * 12 +
            (filingDateObj.getMonth() - dueDateObj.getMonth()) +
            1;
          calculatedInterest = netTax * 0.01 * months;
        }
        break;
      case '234B':
        const taxShortfall = assessedTax - advanceTaxPaid;
        if (taxShortfall > 0 && advanceTaxPaid < assessedTax * 0.9) {
          calculatedInterest = taxShortfall * 0.01 * 12; // Simplified for now
        }
        break;
      case '234C':
        let cumulativeShortfall = 0;
        const liability = taxLiability;
        if (installments.q1 < liability * 0.15) {
          cumulativeShortfall += (liability * 0.15 - installments.q1) * 0.01 * 3;
        }
        if (installments.q2 < liability * 0.45) {
          cumulativeShortfall += (liability * 0.45 - installments.q2) * 0.01 * 3;
        }
        if (installments.q3 < liability * 0.75) {
          cumulativeShortfall += (liability * 0.75 - installments.q3) * 0.01 * 3;
        }
        if (installments.q4 < liability) {
          cumulativeShortfall += (liability - installments.q4) * 0.01 * 1;
        }
        calculatedInterest = cumulativeShortfall;
        break;
      case '234D':
        const excessRefund = refundGranted - actualRefund;
        if (excessRefund > 0) {
          calculatedInterest = excessRefund * 0.005 * 12; // Simplified for now
        }
        break;
      default:
        break;
    }
    setInterest(calculatedInterest);
  };

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-3xl font-bold text-center mb-8">
        Interest Calculator (Sec 234A, 234B, 234C, 234D)
      </h2>
      <div className="max-w-lg mx-auto bg-white rounded-lg shadow-md p-8">
        <div className="mb-4">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Select Section
          </label>
          <select
            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
            value={section}
            onChange={(e) => setSection(e.target.value)}
          >
            <option value="234A">Section 234A</option>
            <option value="234B">Section 234B</option>
            <option value="234C">Section 234C</option>
            <option value="234D">Section 234D</option>
          </select>
        </div>

        {section === '234A' && (
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Taxable Income
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={taxableIncome}
                onChange={(e) => setTaxableIncome(parseFloat(e.target.value))}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Tax Paid
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={taxPaid}
                onChange={(e) => setTaxPaid(parseFloat(e.target.value))}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Due Date of Filing
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="date"
                value={dueDate}
                onChange={(e) => setDueDate(e.target.value)}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Actual Date of Filing
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="date"
                value={filingDate}
                onChange={(e) => setFilingDate(e.target.value)}
              />
            </div>
          </div>
        )}

        {section === '234B' && (
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Assessed Tax
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={assessedTax}
                onChange={(e) => setAssessedTax(parseFloat(e.target.value))}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Advance Tax Paid
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={advanceTaxPaid}
                onChange={(e) => setAdvanceTaxPaid(parseFloat(e.target.value))}
              />
            </div>
          </div>
        )}

        {section === '234C' && (
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Total Tax Liability
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={taxLiability}
                onChange={(e) => setTaxLiability(parseFloat(e.target.value))}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Advance Tax Paid (by 15th June)
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={installments.q1}
                onChange={(e) =>
                  setInstallments({ ...installments, q1: parseFloat(e.target.value) })
                }
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Advance Tax Paid (by 15th Sep)
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={installments.q2}
                onChange={(e) =>
                  setInstallments({ ...installments, q2: parseFloat(e.target.value) })
                }
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Advance Tax Paid (by 15th Dec)
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={installments.q3}
                onChange={(e) =>
                  setInstallments({ ...installments, q3: parseFloat(e.target.value) })
                }
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Advance Tax Paid (by 15th Mar)
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={installments.q4}
                onChange={(e) =>
                  setInstallments({ ...installments, q4: parseFloat(e.target.value) })
                }
              />
            </div>
          </div>
        )}

        {section === '234D' && (
          <div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Refund Granted
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={refundGranted}
                onChange={(e) => setRefundGranted(parseFloat(e.target.value))}
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-bold mb-2">
                Actual Refund Due
              </label>
              <input
                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                type="number"
                value={actualRefund}
                onChange={(e) => setActualRefund(parseFloat(e.target.value))}
              />
            </div>
          </div>
        )}

        <div className="flex items-center justify-center">
          <button
            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
            onClick={calculateInterest}
          >
            Calculate Interest
          </button>
        </div>
        {interest > 0 && (
          <div className="mt-8">
            <h3 className="text-2xl font-bold text-center">
              Calculated Interest: {interest.toFixed(2)}
            </h3>
          </div>
        )}
      </div>
    </div>
  );
};

export default InterestCalculator;
